import(/* webpackMode: "eager", webpackExports: ["BaseTemplate"] */ "/vercel/path0/src/templates/BaseTemplate.tsx");
